<template>
  <v-container grid-list-xs>
    <v-row align="center" justify="center" class="mt-4">
      <v-col cols="12" lg="8" xl="8" class="text-center">
        <h1><p>Comité Académico de la Olimpiada de Química CDMX</p></h1>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="12" xl="7" lg="7" class="text-justify">
        <h3>
          <p>Armando Ariza Castolo (Departamento de Química, CINVESTAV-IPN)</p>
          <p>Héctor García Ortega (Facultad de Química,UNAM)</p>
          <p>Miguel Reina Tapia (Facultad de Química,UNAM)</p>
          <p>Andrés Aguilar Granda (Facultad de Química, UNAM)</p>
        </h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "Olimpiada de Quimica",
    titleTemplate: "Integrantes - %s",
    htmlAttrs: {
      lang: "es",
      amp: true,
    },
  },
};
</script>

<style>
</style>